import React from 'react'
import './ContentBox.css'

const ContentBox = ({ children }) => (
  <div className="ContentBox">{children}</div>
)

export default ContentBox



// WEBPACK FOOTER //
// ./src/components/ContentBox.js